/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import MDAvatar from "components/MDAvatar";
import team2 from "assets/images/team-2.jpg";

// Material-UI components
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import apiClient from "../../../apiClient";
import DataTable from "examples/Tables/DataTable";
import Divider from "@mui/material/Divider";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import MDInput from "components/MDInput";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";

const FetchTenantData = ({ onRefresh, editData }) => {
  const S3_BASE_URL = "https://myflyhomes.s3.ap-south-1.amazonaws.com/";

  const getPrimaryImage = (imageValue) => {
    if (!imageValue) return "";

    const toAbsoluteUrl = (value) => {
      const cleanValue = (value || "").trim();
      if (!cleanValue) return "";
      if (
        cleanValue.startsWith("http://") ||
        cleanValue.startsWith("https://") ||
        cleanValue.startsWith("/") ||
        cleanValue.startsWith("blob:") ||
        cleanValue.startsWith("data:")
      ) {
        return cleanValue;
      }
      return `${S3_BASE_URL}${cleanValue}`;
    };

    if (Array.isArray(imageValue)) {
      return toAbsoluteUrl(imageValue[0]);
    }

    if (typeof imageValue === "string" && imageValue.includes(",")) {
      const firstImage = imageValue
        .split(",")
        .map((item) => item.trim())
        .filter((item) => !!item)[0];
      return toAbsoluteUrl(firstImage);
    }

    return toAbsoluteUrl(imageValue);
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [statusInput, setStatusInput] = useState("Active");
  const [nameFilter, setNameFilter] = useState("");
  const [emailFilter, setEmailFilter] = useState("");
  const [phoneFilter, setPhoneFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [darkMode, setDarkMode] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    title: "",
    onConfirm: null,
  });

  // Fetch states data
  const fetchStates = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get("/admin/tenant");
      const sortedListings = response.data.sort((a, b) => {
        const dateA = new Date(a.added?.at || a.added_at || a.createdAt || 0);
        const dateB = new Date(b.added?.at || b.added_at || b.createdAt || 0);
        return dateB - dateA;
      });
      setData(sortedListings);
    } catch (error) {
      console.error("Error fetching tenant data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStates();
  }, [onRefresh]);

  // Handlers
  const handleActivate = async (id, status) => {
    try {
      setConfirmDialog({
        open: true,
        title:
          "Are you sure you want to " +
          (status === "Active" ? "deactivate" : "activate") +
          " this tenant?",
        onConfirm: async () => {
          try {
            await apiClient.put(`/admin/tenant/${id}`, { status: status });
            await fetchStates(); // Refresh data while staying on the current page
            // Keep current page after refresh
          } catch (error) {
            console.error("Error updating tenant status:", error);
          }
        },
      });
    } catch (error) {
      console.error("Error activating tenant:", error);
    }
  };

  const handleDelete = async (id, name) => {
    try {
      setConfirmDialog({
        open: true,
        title: `Are you sure you want to delete the tenant "${name}"?`,
        onConfirm: async () => {
          try {
            await apiClient.delete(`/admin/tenant/${id}`);
            fetchStates(); // Refresh data after delete
          } catch (error) {
            console.error("Error deleting tenant:", error);
          }
        },
      });
    } catch (error) {
      console.error("Error deleting tenant:", error);
    }
  };

  const handleEdit = (id) => {
    // Handle edit functionality
    console.log("Edit tenant with ID:", id);
    editData(id);
  };

  const handleNameInputChange = (event) => {
    setName(event.target.value);
  };

  const handleEmailInputChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePhoneInputChange = (event) => {
    setPhone(event.target.value);
  };

  const handleStatusInputChange = (event) => {
    setStatusFilter(event.target.value);
  };

  const handleFilterSubmit = () => {
    setNameFilter(name);
    setEmailFilter(email);
    setPhoneFilter(phone);
  };

  const handleClearFilters = () => {
    setNameFilter("");
    setEmailFilter("");
    setPhoneFilter("");
    setStatusFilter("");
    setName("");
    setEmail("");
    setPhone("");
  };

  // Filter the rows based on search term
  const filteredRows = data.filter((row) => {
    return (
      (nameFilter === "" || row.name.toLowerCase().includes(nameFilter.toLowerCase())) &&
      (emailFilter === "" || row.email.toLowerCase().includes(emailFilter.toLowerCase())) &&
      (phoneFilter === "" || row.phone.toLowerCase().includes(phoneFilter.toLowerCase())) &&
      (statusFilter === "" || row.status.toLowerCase().includes(statusFilter.toLowerCase()))
    );
  });

  const columns = [
    { Header: "Name", accessor: "name", width: "25%", align: "left" },
    // { Header: "Email", accessor: "email", align: "left" },
    { Header: "Mobile", accessor: "phone", align: "center" },
    { Header: "Address", accessor: "address", align: "center" },
    { Header: "Added Date", accessor: "added_date", align: "center" },
    { Header: "status", accessor: "status", align: "center" },
    { Header: "Action", accessor: "action", align: "center" },
  ];

  const rows = filteredRows.map((data) => ({
    name: (
      <MDBox display="flex" alignItems="center" lineHeight={1}>
        <MDAvatar
          src={getPrimaryImage(data.images || data.image) || team2}
          name={data.name}
          size="sm"
        />
        <MDBox ml={1.5}>
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {data.name}
          </MDTypography>
        </MDBox>
      </MDBox>
    ),
    // email: (
    //   <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
    //     {data.email}
    //   </MDTypography>
    // ),
    phone: (
      <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
        {data.phone}
      </MDTypography>
    ),
    address: (
      <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
        {data.address}
      </MDTypography>
    ),
    added_date: new Date(data.added?.at).toLocaleDateString(),
    status: (
      <MDBox ml={-1}>
        <MDBadge
          badgeContent={data.status}
          color={data.status === "Active" ? "success" : "warning"}
          variant="gradient"
          size="sm"
        />
      </MDBox>
    ),
    action: (
      <MDBox display="flex" justifyContent="space-around">
        <IconButton onClick={() => handleEdit(data)} color="secondary">
          <EditIcon />
        </IconButton>
        <IconButton
          onClick={() => handleActivate(data._id, data.status)}
          color={data.status === "Active" ? "warning" : "success"}
        >
          <CheckCircleIcon />
        </IconButton>
        <IconButton onClick={() => handleDelete(data._id, data.name)} color="error">
          <DeleteIcon />
        </IconButton>
      </MDBox>
    ),
  }));

  // No data message
  if (loading) return <div>Loading...</div>;
  if (data.length === 0) return <div>No data found.</div>;

  return (
    <div>
      <MDBox
        display="flex"
        gap="1rem"
        mb="1rem"
        justifyContent="left"
        alignItems="left"
        ml="2%"
        width="90%"
      >
        <MDInput
          fullWidth
          label="Name"
          variant="outlined"
          value={name}
          onChange={handleNameInputChange}
        />
        <MDInput
          fullWidth
          label="Email"
          variant="outlined"
          value={email}
          onChange={handleEmailInputChange}
        />
        <MDInput
          fullWidth
          label="Phone"
          variant="outlined"
          value={phone}
          onChange={handlePhoneInputChange}
        />
        <Select
          fullWidth
          variant="outlined"
          value={statusInput}
          onChange={handleStatusInputChange}
          displayEmpty
        >
          <MenuItem value="">
            <em>Status</em>
          </MenuItem>
          <MenuItem value="Active">Active</MenuItem>
          <MenuItem value="Inactive">Inactive</MenuItem>
        </Select>
        <Button
          variant="contained"
          color="primary"
          onClick={handleFilterSubmit}
          sx={{ color: "#fff" }}
        >
          Search
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleClearFilters}
          sx={{ color: "#fff" }}
        >
          Clear
        </Button>
      </MDBox>
      <Divider />
      <DataTable
        table={{ columns, rows }}
        isSorted={true}
        entriesPerPage={true}
        showTotalEntries={true}
        noEndBorder
      />
      <Dialog
        open={confirmDialog.open}
        onClose={() => setConfirmDialog({ ...confirmDialog, open: false })}
        sx={{
          "& .MuiDialog-paper": {
            backgroundColor: darkMode ? "#121212" : "#fff",
            color: darkMode ? "#fff" : "#000",
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1300,
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: darkMode ? "#121212" : "#fff",
            color: darkMode ? "#fff" : "#000",
            borderBottom: `1px solid ${darkMode ? "#333" : "#e0e0e0"}`,
          }}
        >
          {confirmDialog.title}
        </DialogTitle>
        <DialogActions
          sx={{
            backgroundColor: darkMode ? "#121212" : "#fff",
            padding: "16px 24px",
          }}
        >
          <Button
            onClick={() => setConfirmDialog({ ...confirmDialog, open: false })}
            color="inherit"
            sx={{ color: darkMode ? "#ccc" : "#666" }}
          >
            Cancel
          </Button>
          <Button
            onClick={async () => {
              if (confirmDialog.onConfirm) {
                await confirmDialog.onConfirm();
              }
              setConfirmDialog({ ...confirmDialog, open: false });
            }}
            variant="contained"
            color="primary"
            sx={{ color: "#fff", ml: 1 }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
FetchTenantData.propTypes = {
  onRefresh: PropTypes.func.isRequired,
  editData: PropTypes.func.isRequired,
};

export default FetchTenantData;
